import DynamicField from 'src/UI/dynamicUI/layout/DynamicField';
import React from 'react';

type Props = {
  label?: string;
  field: string;
  product: string;
  index?: number;
  readModePrepend?: string;
  readModeAppend?: string;
  hide?: boolean;
};

export const FinancialFormField = ({
  label,
  field,
  product,
  index,
  readModeAppend,
  readModePrepend,
  hide = false,
}: Props) =>
  !hide && (
    <DynamicField
      field={{
        type: 'FIELD',
        label: label,
        span: 12,
        entityType: product,
        entityField: field,
      }}
      index={index}
      readModeAppend={readModeAppend}
      readModePrepend={readModePrepend}
    />
  );
